import MicroModal from "micromodal";

export const useModal = () => {
  MicroModal.init({
    openTrigger: "data-modal-open",
    closeTrigger: "data-modal-close",
    openClass: "is-open",
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });

  const close = (modalId: string) => {
    MicroModal.close(modalId);
  };

  const open = (modalId: string) => {
    MicroModal.show(modalId);
  };

  return { open, close };
};
